module.exports = __webpack_public_path__ + "img/sync-off-red.9aac63d8.svg";